import { render, staticRenderFns } from "./OrnamentHistory2.vue?vue&type=template&id=036a051e&scoped=true&"
import script from "./OrnamentHistory2.vue?vue&type=script&lang=js&"
export * from "./OrnamentHistory2.vue?vue&type=script&lang=js&"
import style0 from "./OrnamentHistory2.vue?vue&type=style&index=0&id=036a051e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a051e",
  null
  
)

export default component.exports